export default __webpack_public_path__ + "static/media/formBg.fd1f58a7.jpg";